import {
    FormControl,
    Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
    autoCompleteSelectOptionsFormat,
    extractDataGroup,
    extractSelectedValues,
    selectedListValues,
} from "../../../../utility/helper";
import { listItemProp } from "utility/types";
import MultiSelectAutoCompleteV1, { ChildComponentRef } from "shared-component/autocomplete-checkbox-multiple-v1";
import { useRef, useState } from "react";

dayjs.extend(utc);

const CdadHeaderCampaignFilterComponent = (props: any) => {
    const childRef = useRef<ChildComponentRef>({ clearSelection: () => { } });
    const [campaign, setCampaign] = useState<string[]>(extractDataGroup(props.unNestedParamData, "campaign") ?? []);
    const [campaignInd, setCampaignInd] = useState<string[]>(extractDataGroup(props.unNestedParamData, "campaignInd") ?? []);
    const [campaignTitle, setCampaignTitle] = useState<string[]>(extractDataGroup(props.unNestedParamData, "campaignTitle") ?? []);
    

    const handleSelection = (selectedList: listItemProp[], filter: string) => {
        const value: string[] = selectedListValues(selectedList);
        switch (filter) {
            case 'campaign':
                setCampaign(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
            case 'campaignInd':
                setCampaignInd(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
            case 'campaignTitle':
                setCampaignTitle(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
        }

    }

    return (
        <div style={{ display: "flex", flexWrap: "wrap", paddingTop: "1rem", justifyContent: "flex-start" }}>
        <div className="signalFilterList" style={{ padding: "8px" }}>
          <Tooltip title={campaignInd?.length > 0 ? campaignInd?.toString() : "Select / Search Campaign Ind"} placement="right">
            <FormControl style={{ width: "210px" }} required>
              <MultiSelectAutoCompleteV1
                items={autoCompleteSelectOptionsFormat(props?.campaignInd)}
                label="Select / Search Campaign Ind"
                selectAllLabel="Select All"
                onChange={(value: listItemProp[]) => {
                  // if (value?.length > 0) handleCANSignalSelection(value)
                  handleSelection(value, 'campaignInd')
                }}
                selectedValues={extractSelectedValues(campaignInd)}
                ref={childRef}
                disabled={props.campaignInd?.length === 0}
              />
            </FormControl>
          </Tooltip>
        </div>
        <div className="signalFilterList" style={{ padding: "8px" }}>
          <Tooltip title={campaign?.length > 0 ? campaign?.toString() : "Select / Search Campaign"} placement="right">
            <FormControl style={{ width: "210px", fontSize: "12px" }} required>
              <MultiSelectAutoCompleteV1
                items={autoCompleteSelectOptionsFormat(props?.campaign)}
                label="Select / Search Campaign"
                selectAllLabel="Select All"
                onChange={(value: listItemProp[]) => {
                  // if (value?.length > 0) handleCANSignalSelection(value)
                  handleSelection(value, "campaign")
                }}
                ref={childRef}
                selectedValues={extractSelectedValues(campaign)}
                disabled={props.campaign?.length === 0}
              />
            </FormControl>
          </Tooltip>
        </div>
        <div className="signalFilterList" style={{ padding: "8px" }}>
          <Tooltip title={campaignTitle?.length > 0 ? campaignTitle?.toString() : "Select / Search Campaign Title"} placement="right">
            <FormControl style={{ width: "210px", fontSize: "12px" }} required>
              <MultiSelectAutoCompleteV1
                items={autoCompleteSelectOptionsFormat(props?.campaignTitle)}
                label="Select / Search Campaign Title"
                selectAllLabel="Select All"
                onChange={(value: listItemProp[]) => {
                  // if (value?.length > 0) handleCANSignalSelection(value)
                  handleSelection(value, "campaignTitle")
                }}
                ref={childRef}
                selectedValues={extractSelectedValues(campaignTitle)}
                disabled={props.campaignTitle?.length === 0}
              />
            </FormControl>
          </Tooltip>
        </div>
      </div>
    );
};

export default CdadHeaderCampaignFilterComponent;
